var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _class3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, hasMany } from '@ember-data/model';
import { underscore, camelize } from '@ember/string';
import { assert } from '@ember/debug';
import { copy } from 'ember-copy';
import { alias, mapBy, filter } from '@ember/object/computed';
import EmberObject, { computed, get, set } from '@ember/object';
import { A } from '@ember/array';
import { isPresent, isNone, isEmpty } from '@ember/utils';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import { inject as service } from '@ember/service';
import TrackRelationships from 'ember-data-relationship-tracker';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
import Enum from '@square/dashboard-utilities/utils/enum';
import { UNIT_OVERRIDE_ONLY_ATTRIBUTES, CATALOG_SERVICE_TEMP_TOKEN_PREFIX } from '@square/dashboard-data/models/catalog/catalog-service-constants';
import { extend } from '@square/dashboard-utilities/utils/keys';
import { intersection, intersectionIsExactlyElement } from '@square/dashboard-utilities/utils/intersection';
import { itemSubunitsServiceActiveSubunits, itemSubunitsServiceAllSubunits } from '@square/dashboard-utilities/utils/item-subunits';
import UUID from 'uuid-js';
function createTempId() {
  return CATALOG_SERVICE_TEMP_TOKEN_PREFIX + UUID.create().toString();
}
const AmountTypes = new Enum(['AMOUNT', 'PERCENTAGE', 'VARIABLE_AMOUNT', 'VARIABLE_PERCENTAGE']);
let _class = (_dec = service(), _dec2 = attr('boolean', {
  allowNull: true
}), _dec3 = attr('number'), _dec4 = attr({
  defaultValue: () => ({})
}), _dec5 = attr({
  defaultValue: () => []
}), _dec6 = alias('version'), _dec7 = computed('_isDirtyOverride', 'dirtyType', 'hasDirtyFields'), _dec8 = fragmentArray('custom-attribute-value'), _dec9 = filter('customAttributes', function (customAttribute) {
  const definition = customAttribute.customAttributeDefinition;
  if (isNone(definition)) {
    return false;
  }
  return definition.isLoaded && definition.isMerchantDefinition;
}), _dec10 = mapBy('merchantCustomAttributes', 'customAttributeDefinition'), _dec11 = attr('boolean', {
  allowNull: true,
  defaultValue: true
}), _dec12 = computed('enabledUnitsAll', {
  get() {
    return this.enabledUnitsAll;
  },
  set(key, value) {
    const oldValue = this.enabledUnitsAll;
    if (oldValue === value) {
      return value;
    }
    const effectiveEnabledUnits = this.subunitsPlusEnabledUnits;
    set(this, 'enabledUnitsAll', value);
    this.setMerchantSubunits(effectiveEnabledUnits, value);
    return value;
  }
}), _dec13 = hasMany('merchant-subunit-ed', {
  async: false
}), _dec14 = hasMany('merchant-subunit-ed', {
  async: false
}), _dec15 = computed('_effectiveEnabledUnitsOverride', 'disabledUnits.[]', 'enabledUnits.[]', 'globallyEnabled', {
  get() {
    if (this._effectiveEnabledUnitsOverride) {
      return this._effectiveEnabledUnitsOverride;
    }
    return A(this._effectiveEnabledUnits());
  },
  set(key, value) {
    this.set('_effectiveEnabledUnitsOverride', value);
    return value;
  }
}), _dec16 = computed('globallyEnabled', 'enabledUnits.[]', 'disabledUnits.[]', function () {
  return this._effectiveEnabledUnits(true);
}), _dec17 = alias('effectiveEnabledUnits'), _dec18 = mapBy('subunits', 'token'), _dec19 = computed('subunits', 'enabledUnits.[]', function () {
  const subunits = A([...this.subunits]);
  const subunitTokens = subunits.mapBy('token');
  this.enabledUnits.forEach(unit => {
    if (!subunitTokens.includes(unit.token)) {
      subunits.addObject(unit);
    }
  });
  return subunits;
}), _dec20 = alias('userInfo.currentUser'), _class2 = (_class3 = class _class2 extends EmberDataBaseModel.extend(TrackRelationships) {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _initializerDefineProperty(this, "deleted", _descriptor2, this);
    _initializerDefineProperty(this, "version", _descriptor3, this);
    _initializerDefineProperty(this, "unitOverrides", _descriptor4, this);
    _initializerDefineProperty(this, "unknownAttrs", _descriptor5, this);
    // ember-data-relationship-tracker uses this field to snapshot model
    _initializerDefineProperty(this, "relationshipTrackerVersion", _descriptor6, this);
    _initializerDefineProperty(this, "customAttributes", _descriptor7, this);
    _initializerDefineProperty(this, "merchantCustomAttributes", _descriptor8, this);
    _initializerDefineProperty(this, "merchantCustomAttributeDefinitions", _descriptor9, this);
    // PRIVATE
    _initializerDefineProperty(this, "enabledUnitsAll", _descriptor10, this);
    // USE globallyEnabled, NOT enabledUnitsAll
    _initializerDefineProperty(this, "globallyEnabled", _descriptor11, this);
    _initializerDefineProperty(this, "enabledUnits", _descriptor12, this);
    _initializerDefineProperty(this, "disabledUnits", _descriptor13, this);
    // Used to get all enabled units for items that are globally enabled
    _initializerDefineProperty(this, "effectiveEnabledUnits", _descriptor14, this);
    _initializerDefineProperty(this, "effectiveEnabledUnitsForMerchant", _descriptor15, this);
    // Trying to get away from subunits eventually, but
    // need to keep the alias for the current items
    // views / subunit filter mixin that expects these values
    _initializerDefineProperty(this, "subunits", _descriptor16, this);
    _initializerDefineProperty(this, "subunitTokens", _descriptor17, this);
    _initializerDefineProperty(this, "subunitsPlusEnabledUnits", _descriptor18, this);
    _initializerDefineProperty(this, "currentUser", _descriptor19, this);
  }
  static createDefault(store, merchantSubunits) {
    assert('Please add `.reopenClass({ _modelNameForMigration: "model-name-goes-here"})` to the model class.', isPresent(this._modelNameForMigration));
    const newObject = store.createRecord(this._modelNameForMigration, this.createDefaultOptions(store));
    if (!isNone(merchantSubunits)) {
      newObject.addMerchantSubunits(merchantSubunits);
    }
    return newObject;
  }
  static createDefaultOptions() {
    return {};
  }

  // note: MUST BE OVERRIDDEN, e.g. 'models/menu-category' -> 'CATEGORY'
  static catalogType() {
    assert('Please implement catalogType() function', false);
  }
  init(...args) {
    super.init(...args);
    if (this.isNew && this._shouldDisableEnabledUnitsAll()) {
      set(this, 'enabledUnitsAll', false);
    }
  }
  rollbackAttributes() {
    super.rollbackAttributes();
    this.rollbackRelationships();
  }

  // the `TrackRelationships` overrides `save` but doesn't resolve to the item.
  async save(...args) {
    await super.save(...args);
    return this;
  }

  // 'set' without 'watch' doesn't make a relationship dirty.
  watchAndSet(relationshipName, value) {
    this.watchRelationship(relationshipName, () => {
      set(this, relationshipName, value);
    });
  }

  /*
   Our API expects newly created objects to have a temporary client id when saved. This id is used to reference
   the object in other objects saved in the same batch. This function also gives us a way to get a string reference
   to a model before it has been saved.
    When using this function in application code make sure to update references
   that might have a temp id after saving the referenced objects.
  */
  idOrTempId() {
    if (this.id) {
      return this.id;
    } else {
      if (!this.tempId) {
        set(this, 'tempId', createTempId());
      }
      return this.tempId;
    }
  }
  get isDirty() {
    if (this._isDirtyOverride !== undefined) {
      return this._isDirtyOverride;
    }
    if (this.hasDirtyFields) {
      return true;
    }
    return !isEmpty(this.dirtyType);
  }
  set isDirty(value) {
    set(this, '_isDirtyOverride', value);
  }
  trimNameAndSku() {
    const name = this.name;
    if (isPresent(name)) {
      const trimmedName = name.trim();
      set(this, 'name', trimmedName);
    }
    const sku = this.sku;
    if (isPresent(sku)) {
      const trimmedSku = sku.trim();
      set(this, 'sku', trimmedSku);
    }
  }
  enabledForUnit(unitToken) {
    if (isNone(unitToken)) {
      return false;
    }
    return A(this.effectiveEnabledUnits).mapBy('token').includes(unitToken);
  }
  _effectiveEnabledUnits(allForMerchant = false) {
    let subunits;
    if (this.globallyEnabled) {
      subunits = itemSubunitsServiceActiveSubunits(allForMerchant);
    } else {
      subunits = this.enabledUnits || [];
      const authorizedAndActiveUnitTokens = A(itemSubunitsServiceActiveSubunits(allForMerchant)).mapBy('token');
      subunits = subunits.filter(unit => authorizedAndActiveUnitTokens.includes(unit.token));
    }
    const disabledUnitTokens = A(this.disabledUnits || []).mapBy('token');
    return subunits.filter(unit => !disabledUnitTokens.includes(unit.token));
  }
  addMerchantSubunit(merchantSubunit) {
    this.addMerchantSubunits([merchantSubunit]);
  }
  addMerchantSubunits(merchantSubunits) {
    if (isPresent(merchantSubunits)) {
      if (!this.globallyEnabled) {
        // Resolve passed in subunit objects to merchant-subunit-ed models
        const unitModels = merchantSubunits.map(merchantSubunit => this.store.peekRecord('merchant-subunit-ed', merchantSubunit.token));
        const enabledTokens = new Set(A(this.enabledUnits).mapBy('token'));
        this.watchRelationship('enabledUnits', () => {
          set(this, 'enabledUnits', [...this.enabledUnits.toArray(), ...unitModels.filter(unit => !enabledTokens.has(unit.token))]);
        });
      }
      const enabledUnits = A([...this.subunitsPlusEnabledUnits]);
      enabledUnits.addObjects(merchantSubunits);
      const enabledTokens = new Set(enabledUnits.mapBy('token'));
      const disabledUnits = this.disabledUnits;
      const newDisabledUnits = disabledUnits.filter(unit => !enabledTokens.has(unit.token));
      if (disabledUnits.length !== newDisabledUnits.length) {
        this.watchRelationship('disabledUnits', () => {
          set(this, 'disabledUnits', newDisabledUnits);
        });
      }
    }
  }
  removeMerchantSubunit(subunitToken) {
    const enabledUnits = this.enabledUnits;
    const targetUnit = enabledUnits.findBy('token', subunitToken);
    if (!isNone(targetUnit)) {
      this.watchRelationship('enabledUnits', () => {
        set(this, 'enabledUnits', this.enabledUnits.without(targetUnit));
      });
    }
    if (this.globallyEnabled) {
      const targetUnit = itemSubunitsServiceAllSubunits().find(unit => unit.token === subunitToken);
      if (!isNone(targetUnit)) {
        this.watchRelationship('disabledUnits', () => {
          set(this, 'disabledUnits', this.disabledUnits.toArray().addObject(targetUnit));
        });
      }
    }
  }

  // setMerchantSubunits updates enabledUnits's and disabledUnits's based on the passed subunits list and the globally enabled state
  // ***DO NOT USE*** this function when editing an existing object. Using this function with employees that don't have access to all
  // of a merchant's subunits causes subunits to be removed from the object. When editing an existing object's locations always
  // use the addMerchantSubunit and removeMerchantSubunit functions above.
  // ****************
  // The need for the disabledUnits param is explained in CATALOG-3038
  setMerchantSubunits(merchantSubunits, globallyEnabled = null, disabledUnits = null) {
    if (isNone(globallyEnabled)) {
      globallyEnabled = this.globallyEnabled;
    }
    this.watchRelationship('enabledUnits', () => {
      if (globallyEnabled) {
        // inactive units still need to be explicity enabled to keep the object graph consistent
        set(this, 'enabledUnits', A(merchantSubunits).rejectBy('unitActive'));
      } else {
        set(this, 'enabledUnits', merchantSubunits);
      }
    });
    const enabledTokens = A(merchantSubunits).mapBy('token');
    let subunitsToFilter;
    if (globallyEnabled) {
      subunitsToFilter = itemSubunitsServiceActiveSubunits();
    } else {
      subunitsToFilter = this.disabledUnits?.toArray() || [];
    }
    if (isPresent(disabledUnits)) {
      const tokens = A(subunitsToFilter).mapBy('token');
      subunitsToFilter = [...subunitsToFilter, ...disabledUnits.filter(unit => !tokens.includes(unit.token))];
    }
    this.watchRelationship('disabledUnits', () => {
      set(this, 'disabledUnits', subunitsToFilter.filter(unit => !enabledTokens.includes(unit.token)));
    });
  }
  filterByAffectedBySubunit(targetUnitToken, allTokens) {
    return other => {
      if (isEmpty(allTokens)) {
        return true;
      }
      const otherSubunitTokens = A(other.get('subunits')).mapBy('token');
      return intersectionIsExactlyElement(allTokens, otherSubunitTokens, targetUnitToken);
    };
  }
  commonSubunits(other) {
    const subunits = A(this.subunits);
    const otherUnits = A(other.get('subunits'));
    const commonSubunitTokens = intersection(subunits.mapBy('token'), otherUnits.mapBy('token'));
    const allUnits = itemSubunitsServiceActiveSubunits();
    return allUnits.filter(subunit => commonSubunitTokens.includes(subunit.token));
  }
  setUnitOverride(unitToken, key, value) {
    if (isNone(unitToken) || isNone(key) || isNone(value)) {
      return null;
    }
    const unitOverrides = extend(true, {}, this.unitOverrides);
    if (!unitOverrides[unitToken]) {
      unitOverrides[unitToken] = {};
    }
    let setUnitOverrides = false;
    if (UNIT_OVERRIDE_ONLY_ATTRIBUTES.includes(key) && unitOverrides[unitToken][key] === undefined) {
      if (!isNone(value)) {
        unitOverrides[unitToken][key] = value;
        setUnitOverrides = true;
      }
    } else if (unitOverrides[unitToken][key] !== value) {
      unitOverrides[unitToken][key] = value;
      setUnitOverrides = true;
    }
    if (setUnitOverrides) {
      set(this, 'unitOverrides', unitOverrides);
    }
    return value;
  }
  getUnitOverride(unitToken, key) {
    return get(this, `unitOverrides.${unitToken}.${key}`);
  }
  getUnitAttribute(unitToken, attrKey) {
    const override = this.getUnitOverride(unitToken, underscore(attrKey));
    if (isNone(override)) {
      return get(this, camelize(attrKey));
    }
    return override;
  }
  getUnitAttributes(unitToken, attrKeys) {
    const obj = EmberObject.create();
    attrKeys.forEach(key => {
      obj.set(key, this.getUnitAttribute(unitToken, key));
    });
    return obj;
  }
  removeUnitOverride(unitToken, key) {
    const unitOverrides = copy(this.unitOverrides, true);
    if (isNone(unitOverrides[unitToken]) || isNone(unitOverrides[unitToken][key])) {
      return;
    }
    delete unitOverrides[unitToken][key];
    set(this, 'unitOverrides', unitOverrides);
  }
  removeAllUnitOverridesByKeys(keys) {
    if (isEmpty(keys)) {
      return;
    }
    const unitOverrides = copy(this.unitOverrides, true);
    keys.forEach(key => {
      for (const unitOverride in unitOverrides) {
        delete unitOverrides[unitOverride][key];
        if (isEmpty(unitOverrides[unitOverride])) {
          delete unitOverrides[unitOverride];
        }
      }
    });
    set(this, 'unitOverrides', unitOverrides);
  }
  getAttributeValueAndOverrides(attrKey, onlyIncludeActiveOverrides = false) {
    const global = get(this, attrKey);
    const unitOverrides = this.unitOverrides;
    const underAttrKey = underscore(attrKey);
    const overrides = Object.keys(unitOverrides).reduce((acc, unit) => {
      const unitOverride = unitOverrides[unit][underAttrKey];
      if (!isNone(unitOverride) && (!onlyIncludeActiveOverrides || this.enabledForUnit(unit))) {
        acc.push({
          value: unitOverride,
          unitToken: unit
        });
      }
      return acc;
    }, []);
    return {
      global,
      overrides
    };
  }
  _shouldDisableEnabledUnitsAll() {
    if (this.constructor.currentUserAffectsEnabledUnitsAll === false) {
      return false;
    }
    try {
      // eslint-disable-next-line dashboard/prefer-user-services
      const currentUser = this.userInfo.currentUser;
      if (!isNone(currentUser)) {
        // if currentUser is an employee that does not have access to all subunits then newly created items should not be
        // globally enabled by default
        if (isPresent(currentUser.subunits) && isPresent(currentUser.merchantSubunits) && currentUser.subunits.length !== currentUser.merchantSubunits.length) {
          return true;
        }
      }
    } catch {
      return false;
    }
    return false;
  }
  toJSON() {
    // The next 3 lines are basically calling this._super() except that we're using the serializer for this model instead
    // of Ember Data's default JSON serializer
    const serializer = this._internalModel.store.serializerFor('items-v3-base');
    const snapshot = this._internalModel.createSnapshot();
    return serializer.serialize(snapshot, {});
  }
  inheritEnabledUnits(from) {
    if (isNone(from)) {
      throw new Error('no object to inherit from');
    }
    set(this, 'enabledUnitsAll', from.get('globallyEnabled'));
    this.watchRelationship('enabledUnits', () => {
      set(this, 'enabledUnits', from.get('enabledUnits'));
    });
    this.watchRelationship('disabledUnits', () => {
      set(this, 'disabledUnits', from.get('disabledUnits'));
    });
  }
  inheritIntersectionOfEnabledUnits(from1, from2) {
    if (isNone(from1) || isNone(from2)) {
      throw new Error('no objects to inherit from');
    }
    if (from1.get('globallyEnabled') && from2.get('globallyEnabled')) {
      // If from1 and from2 are both globally enabled, the result object should be globally enabled
      // and disabled for the union of units disabled for from1 and from2.
      const disabledUnits = [...from1.disabledUnits, ...from2.disabledUnits].uniq();
      set(this, 'enabledUnitsAll', true);
      this.watchRelationship('disabledUnits', () => {
        set(this, 'disabledUnits', disabledUnits);
      });
    } else if (from1.get('globallyEnabled') || from2.get('globallyEnabled')) {
      // either from1 or from2 is globally enabled but the other one is not
      const globallyEnabledModel = from1.get('globallyEnabled') ? from1 : from2;
      const globallyDisabledModel = from1.get('globallyEnabled') ? from2 : from1;

      // If one is globally enabled but not the other,
      // the object should be enabled for all units at which the globally disabled object
      // is enabled as long as the globally enabled object does not explicitly disable the unit.
      const globallyEnabledModelDisabledUnitTokens = A(globallyEnabledModel.get('disabledUnits')).mapBy('token');
      const enabledUnits = globallyDisabledModel.get('enabledUnits').filter(subunit => {
        // enable a subunit if it's not disabled by the globally enabled model
        return !globallyEnabledModelDisabledUnitTokens.includes(subunit.token);
      });
      set(this, 'enabledUnitsAll', false);
      this.watchRelationship('enabledUnits', () => {
        set(this, 'enabledUnits', enabledUnits);
      });
    } else {
      // If from1 and from2 are both globally disabled, the object should be globally disabled,
      // and enabled for intersection of units enabled in from1 and from2.
      const enabled1 = from1.get('enabledUnits').toArray();
      const enabled2 = from2.get('enabledUnits').toArray();
      const enabledUnits = intersection(enabled1, enabled2);
      set(this, 'enabledUnitsAll', false);
      this.watchRelationship('enabledUnits', () => {
        set(this, 'enabledUnits', enabledUnits);
      });
    }
  }
}, _defineProperty(_class3, "dataSource", 'CATALOG'), _defineProperty(_class3, "currentUserAffectsEnabledUnitsAll", true), _defineProperty(_class3, "AmountTypes", AmountTypes), _defineProperty(_class3, "sortKey", null), _class3), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "userInfo", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "deleted", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "version", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "unitOverrides", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "unknownAttrs", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "relationshipTrackerVersion", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "isDirty", [_dec7], Object.getOwnPropertyDescriptor(_class2.prototype, "isDirty"), _class2.prototype), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "customAttributes", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "merchantCustomAttributes", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "merchantCustomAttributeDefinitions", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "enabledUnitsAll", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "globallyEnabled", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "enabledUnits", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "disabledUnits", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "effectiveEnabledUnits", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, "effectiveEnabledUnitsForMerchant", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, "subunits", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, "subunitTokens", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, "subunitsPlusEnabledUnits", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class2.prototype, "currentUser", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
export { _class as default };